export default __webpack_public_path__ + "9f41fabe47fecab3754dad38db6877c7.webp";